import axios from "../../axios";

export function tracker__get_started(trackerid) {
    return (async dispatch => {
        try {
            let response = await axios.get(`Trackers/${trackerid}/started`);
            dispatch({
                type: "TRACKERS_TOUR_START",
                payload: {
                    data: { id: trackerid, info: response.data },
                    error: null
                }
            });
        }
        catch (error) {
            dispatch({
                type: "TRACKER_STARTED_REJECTED",
                payload: {
                    data: null,
                    error: error
                }
            });
        }
    })
}


// WEBPACK FOOTER //
// ./src/redux/actions/trackers.js